import { FC } from 'react';
import { Typography, TypographyProps } from 'omakase';
import { consumerHelpItem } from 'routes/business/helpRouteCssDefs';

interface HelpItemProps {
  title: string;
  bigger?: boolean;
}

export const HelpItem: FC<HelpItemProps> = ({ title, children, bigger }) => {
  const titleVariant: TypographyProps['variant'] = bigger ? 'heading02' : 'heading04';
  return (
    <div css={consumerHelpItem}>
      <Typography component={bigger ? 'h2' : 'h3'} variant={titleVariant} mb={1}>
        {title}
      </Typography>
      <Typography component="section" variant="body02">
        {children}
      </Typography>
    </div>
  );
};
